import { Bicicleta } from "./bicicleta";
import { Casa } from "./casa";
import { Catedral } from "./catedral";
import { Cocina } from "./cocina";
import { Platano } from "./platano";

export const IMAGES = {
  bicicleta: Bicicleta,
  casa: Casa,
  catedral: Catedral,
  cocina: Cocina,
  platano: Platano,
};
